<ng-container *ngIf="dataStream$ | async as dataList">
  <div class="title-container">
    <span class="title">{{
      'orderSearch.client' | translate
    }}</span>
    <span class="title">{{
      'orderSearch.order' | translate
    }}</span>
    <span class="title mobile-hidden">{{
      'orderSearch.initiatingLocation' | translate
    }}</span>
    <span class="title mobile-hidden">{{
      'orderSearch.pickupLocation' | translate
    }}</span>
    <div class="mobile-smaller title desktop-hidden">
      <mat-icon>store</mat-icon>
    </div>
    <div class="mobile-smaller title desktop-hidden">
      <mat-icon>shopping_bag</mat-icon>
    </div>
    <span class="title red-text mobile-hidden">{{
      'orderSearch.returnTitle' | translate
    }}</span>
    <span class="mobile-medium title">{{ 'orderSearch.date' | translate }}</span>
  </div>
  <cdk-virtual-scroll-viewport
    class="order-table"
    *ngIf="this.currentArray.length > 0"
    [itemSize]="120"
    (scrolledIndexChange)="nextBatch()">
    <li *cdkVirtualFor="let data of dataList; let index = index;">
      <mat-card
        class="order-container"
        (click)="saleClicked(data)">
        <div class="info-container">
          <div class="info">
            <span class="name text" data-dd-action-name="Client Name" data-dd-privacy="mask">{{ getName(data.client) }}</span>
            <span class="text" data-dd-action-name="Client Phone" data-dd-privacy="mask">{{ getPhone(data.client) }}</span>
            <div class="ellipsis-text-box">
              <span class="ellipsis-text" data-dd-action-name="Client Email" data-dd-privacy="mask">{{ getEmail(data.client) }}</span>
            </div>
          </div>
          <div class="info">
            <span class="text">{{(data.type === "RETAILTRANSACTION" || data.type === "RETAILORDER" ? 'orderSearch.retail'  : 'orderSearch.ecomm') | translate}}
                {{ getSource(data.order?.siteSourceId) }}
            </span>
            <span *ngIf="data.orderType" class="text mobile-hidden">
                {{ data.orderType |translate }} - {{ data.status | translate }}
            </span>
            <span *ngIf="!data.orderType && data.status" class="text mobile-hidden">
              {{ data.status | translate }}
            </span>
            <span class="text">{{ data.type === "RETAILORDER" ? data.saleChId : data.id }}</span>
          </div>
          <div class="mobile-smaller info">
            <span class="text">{{data.initiatingLocation}}</span>
          </div>
          <div class="mobile-smaller info">
            <span class="text">{{data.pickupLocation}}</span>
          </div>
          <div class="info mobile-hidden">
            <div *ngIf="!msAuthService.isRetail()">
              <div class="ellipsis-text-box">
                <span *ngIf="data.returns[0]" class="ellipsis-text red-text">{{data.returns[0].name}}</span>
              </div>
              <div class="ellipsis-text-box">
                <span *ngIf="data.returns[1]" class="ellipsis-text red-text">{{data.returns[1].name}}</span>
              </div>
              <div class="ellipsis-text-box">
                <span *ngIf="data.returns[2]" class="ellipsis-text red-text">{{data.returns[2].name}}</span>
              </div>
              <div class="ellipsis-text-box">
                <span *ngIf="data.returns[3]" class="ellipsis-text red-text">{{data.returns[3].name}}</span>
              </div>
            </div>
            <span *ngIf="data.returns.length > 0 && msAuthService.isRetail()" class="text red-text">{{'orderSearch.containsReturns' | translate}}</span>
          </div>
          <div class="mobile-medium info">
            <span class="text">{{ data.date }}</span>
            <div *ngIf="!msAuthService.isRetail()">
              <div class="ellipsis-text-box">
                <span *ngIf="data.returns[0]" class="desktop-hidden ellipsis-text red-text">{{data.returns[0].name}}</span>
              </div>
              <div class="ellipsis-text-box">
                <span *ngIf="data.returns[1]" class="desktop-hidden ellipsis-text red-text">{{data.returns[1].name}}</span>
              </div>
              <div class="ellipsis-text-box">
                <span *ngIf="data.returns[2]" class="desktop-hidden ellipsis-text red-text">{{data.returns[2].name}}</span>
              </div>
              <div class="ellipsis-text-box">
                <span *ngIf="data.returns[3]" class="desktop-hidden ellipsis-text red-text">{{data.returns[3].name}}</span>
              </div>
            </div>
            <span *ngIf="data.returns.length > 0 && msAuthService.isRetail()" class="desktop-hidden text red-text">{{'orderSearch.containsReturns' | translate}}</span>
          </div>
        </div>
      </mat-card>
    </li>
    <div class="spinner" *ngIf="loading">
      <mat-spinner [diameter]="50"></mat-spinner>
    </div>
  </cdk-virtual-scroll-viewport>
</ng-container>
<div class="spinner" *ngIf="loading && currentArray.length === 0">
  <mat-spinner></mat-spinner>
</div>
